// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"212":"2a4ffc21","476":"37cd95eb","504":"0b6f2d37","783":"b33bac4b"}[chunkId] + ".chunk.js";
};